/**
 * userDirectory — resolve a stored actor token to a human display name.
 *
 * Lifecycle columns (tax_bills.received_by / approved_by, filed_returns.prepared_by /
 * reviewed_by, …) store the acting user's EMAIL when written by the workflow
 * (processBill / processReturn stamp `userEmail`), but seed + legacy rows can hold
 * the user ID instead — so we match a token against BOTH id and email. The name is
 * built from the contact's first/last name (the `/api/users-list` JOIN), falling
 * back to the email, then the raw token. Returns null only when there's no actor,
 * so callers that render "date · by" can omit the "· by" cleanly.
 */
export interface DirectoryUser {
  id: string;
  email: string | null;
  role?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  employee_title?: string | null;
}

export function userNameFrom(
  users: DirectoryUser[] | undefined,
  who: string | null | undefined,
): string | null {
  if (!who) return null;
  const u = (users ?? []).find((x) => x.id === who || x.email === who);
  if (!u) return who;
  const full = `${u.first_name ?? ''} ${u.last_name ?? ''}`.trim();
  return full || u.email || who;
}
